// extracted by mini-css-extract-plugin
module.exports = {"btn":"Button_btn__3xaJM","justIcon":"Button_justIcon__3mf9m","clickBtn":"Button_clickBtn__2ov3k","icon":"Button_icon__23JL_"};